import {getOutlet} from 'reconnect.js';

export function sliceTailSlash(path = '') {
  if (path[path.length - 1] === '/') {
    return path.slice(0, -1);
  }

  return path;
}

export function getNavItems(props) {
  const _navbarConfig = getOutlet('navbarConfig').getValue();

  const navbarConfig =
    _navbarConfig || props.pageContext?.prebuiltSiteConfig?.navbar_config;
  const navItems =
    (props.isDoctor
      ? navbarConfig?.doctor?.entries
      : navbarConfig?.people?.entries) || [];

  return navItems;
}

export function isNavLinkSelected(navItem) {
  if (
    typeof window !== 'undefined' &&
    typeof window.location?.pathname === 'string'
  ) {
    return (
      sliceTailSlash(window.location.pathname) === sliceTailSlash(navItem.path)
    );
  }
  return false;
}

export function getNavLinkExtraProps(navItem) {
  if (
    navItem.path.indexOf('/profile') === 0 ||
    navItem.path.indexOf('/checkout') === 0 ||
    navItem.path.indexOf('/products') === 0 ||
    navItem.path.indexOf('/articles') === 0
  ) {
    return {
      loading: true,
    };
  }
  return {
    loading: 600,
  };
}

export function getFooterNavItems(props) {
  const defaultNavItems = [
    {name: '商品', path: '/products'},
    {name: '文章', path: '/articles'},
    {name: '品牌', path: '/about'},
  ];

  const _footerConfig = getOutlet('footerConfig').getValue();
  const footerConfig =
    _footerConfig || props.pageContext?.prebuiltSiteConfig?.footer_config;

  const navItems =
    (footerConfig &&
      footerConfig.entries?.length > 0 &&
      footerConfig.entries) ||
    defaultNavItems;

  return navItems;
}

export function getFooterConfig(props) {
  const _footerConfig = getOutlet('footerConfig').getValue();

  const footerConfig =
    _footerConfig || props.pageContext?.prebuiltSiteConfig?.footer_config;

  return footerConfig || {};
}
